module.exports = __webpack_public_path__ + "static/media/add.49754825.svg";